import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('energyProviders', {
  parent: 'lists'
})
